import { LanguageCode } from "./languages/types";

export const formatNumber = (
  value: number,
  options: Intl.NumberFormatOptions,
  language: LanguageCode
): string => value.toLocaleString(language, options);
